import { createTheme, ThemeProvider } from '@mui/material/styles';
import "./CSS/AboutPage.css"
import Navbar from './Navbar';
import ContactHeader from './Contact/ContactHeader';
import ContactMainSection from './Contact/ContactMainSection';
import Footer from './Footer';

const theme = createTheme({
    palette: {
      primary: {
        main: "#ffffff",
      },
      secondary: {
        main: '#C5A47E',
      },
    },
    typography:{
      fontFamily:'Barlow'
    }
  });
  
export const ContactPage = () => {
  return (
   
     <ThemeProvider theme={theme}>
        <Navbar/>
       <ContactHeader/>
       <ContactMainSection/>
       <iframe
      title="Z.J Associates location map"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d425.7326604238623!2d74.1652330786641!3d31.390388208265176!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3918ff0012bcac79%3A0xc8e3c29a75fcde5!2sZ.J%20associates!5e0!3m2!1sen!2s!4v1776599494133!5m2!1sen!2s"
      width="100%"
      height="450"
      style={{ border: 0, borderRadius: "10px", marginBottom: "50px" }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
       <Footer/>
     </ThemeProvider>
   
  );
}
